export default class RemoveTpClientInvoiceLineItems {
  constructor() {
    this.RemoveItemIds = [];
    this.TpClientInvoiceId = null;
    this.JobLineSearchItem = null;
    this.LineItemSearchItem = null;
    this.LineItemListType = '';
    this.AllItemsInTheSearchSetAreSelected = false;
  }
}
